import { Dialog, DialogTitle, Fab, Grid, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { allRoles } from 'config';
import CheckIcon from '@mui/icons-material/Check';
import config, { prodProjeEskgId, projeEskgId, testProjeEskgId } from '../../../config';
import RoleUnitDataTable from '../DataTable/RoleUnitDataTable';
import { useSelector } from 'react-redux';
import { isRoleCheckList } from 'app/utils/appHelpers';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function RoleReportingListDialog({ handleCloseRole, onClose, open, pageTitle }) {

  const [loading, setLoading] = useState(true);
  let [allRolesData, setAllRolesData] = useState([]);
  const [allInstData, setAllInstData] = useState([]);
  const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts);

  const handleListItemClick = async (item) => {
    onClose(); // Dialog'u kapat
    await handleCloseRole(374, item.inst);
  };

  const handleClose = async () => {
    onClose();
  };

  useEffect(() => {
    // Sadece bir kez çalışsın
    setAllInstData(config.institutions.filter(x => allAuthorizedInsts.includes(x.inst)));
  }, [allAuthorizedInsts])

  
  return (
    <React.Fragment>
      <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth scroll="paper">
        <DialogTitle sx={{  }}>{pageTitle} / Kurum Seçiniz</DialogTitle>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} lg={12}>
            <List disablePadding>
              {allInstData.map((item) => (
                <ListItemButton
                  component={"li"}
                  alignItems={"flex-start"}
                  sx={{
                    borderBottom: 1,
                    borderBottomColor: 'divider',
                    px: 3,
                  }}
                >
                  <ListItemText
                    primary={<Typography component={"div"}>
                      <Typography variant={"body1"} mb={1} sx={{  }}>
                        {item.inst}
                      </Typography>
                    </Typography>} />

                  <ListItemIcon
                    className={"ListItemIcons"}
                    sx={{
                      position: 'absolute',
                      right: 10,
                      bottom: 6,
                      transition: 'all 0.2s',
                    }}
                  >
                    <Fab size="small" color={"primary"} onClick={() => handleListItemClick(item)} key={item.inst}
                      sx={{
                        bgcolor: 'grey.300',
                        '&:hover': {
                          bgcolor: (theme) => theme.palette.primary.main
                        },
                        width: 35,
                        height: 35,
                        minHeight: 35,
                        '& .MuiSvgIcon-root': {
                          fontSize: '1rem'
                        }
                      }}
                    ><CheckIcon /></Fab>
                  </ListItemIcon>
                </ListItemButton>
              ))}
            </List>
          </Grid>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
}

export default RoleReportingListDialog